import { render, staticRenderFns } from "./TicketRequest.view.vue?vue&type=template&id=afe38936&scoped=true"
import script from "./TicketRequest.view.vue?vue&type=script&lang=js"
export * from "./TicketRequest.view.vue?vue&type=script&lang=js"
import style0 from "./TicketRequest.view.vue?vue&type=style&index=0&id=afe38936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe38936",
  null
  
)

export default component.exports